// removed by extract-text-webpack-plugin
module.exports = {"mainInstruct":"src-components-NonTradedDetail-___NonTradedInfo__mainInstruct___1ID-b","instructText":"src-components-NonTradedDetail-___NonTradedInfo__instructText___3TScR","instructLabel":"src-components-NonTradedDetail-___NonTradedInfo__instructLabel___1C7ZK","link":"src-components-NonTradedDetail-___NonTradedInfo__link___3TAA_","list":"src-components-NonTradedDetail-___NonTradedInfo__list___3eJbL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NonTradedDetail/NonTradedInfo.css
// module id = 1184
// module chunks = 3